import React from 'react'

function ExtraLinks({ location }) {
    let show = ''
    if (location === "Contact") {
        show = '/contact'
    }
    if (location === "Blogs") {
        show = '/blogs'
    }
    if (location === "RushX") {
        show = 'https://rushx.pythonanywhere.com'
    }
    if (location === "Portfolio") {
        show = 'https://amanojha.pythonanywhere.com'
    }
    if (location) {
        show = `/cateogary/${location}`
    }
    return (
        <li><a href={`${show}`}>{location.charAt(0).toUpperCase() + location.slice(1)}</a></li>
    )
}

export default ExtraLinks
